import mergeSort, {
  stringCompare,
} from '../../../../../../../../Utils/mergeSort';
import { IBokningsrubrik } from '../../../../../ObjektVyer/Aktivitet/AktivitetResursValjare';
import { IKalenderResourceTooltipInfo } from '../../KalenderTooltipComponent';

export interface ISortableResource {
  posNr?: number | null;
  prio_ordning?: number | null;
  BO_RESURS_ID?: string;
  aktResRub_PosNr?: number | null;
  bo_resurs_id?: string;
}

/**
 * Compares two resources based on posNr/aktResRub_PosNr (ascending), prio_ordning, and bo_resurs_id
 */
export const compareResources = (
  a: ISortableResource,
  b: ISortableResource
): number => {
  // If both have posNr or aktResRub_PosNr, compare them
  const aPos = a?.posNr ?? a?.aktResRub_PosNr;
  const bPos = b?.posNr ?? b?.aktResRub_PosNr;

  if (aPos != null && bPos != null) {
    return aPos - bPos;
  }
  // If only a has position, it should come first
  if (aPos != null) {
    return -1;
  }
  // If only b has position, it should come first
  if (bPos != null) {
    return 1;
  }
  // If both have prio_ordning, compare them
  if (a?.prio_ordning != null && b?.prio_ordning != null) {
    return a.prio_ordning - b.prio_ordning;
  }
  // Finally, sort by resource ID
  const aId = a?.BO_RESURS_ID ?? a?.bo_resurs_id ?? '';
  const bId = b?.BO_RESURS_ID ?? b?.bo_resurs_id ?? '';
  return stringCompare(aId, bId);
};

/**
 * Sorts an array of booking headers (IBokningsrubrik)
 */
export const sortBokningsrubriker = (
  values: IBokningsrubrik[]
): IBokningsrubrik[] => {
  return mergeSort(values, compareResources);
};

/**
 * Sorts an array of calendar resources (IKalenderResourceTooltipInfo)
 */
export const sortKalenderResources = (
  resources: IKalenderResourceTooltipInfo[] | undefined
): IKalenderResourceTooltipInfo[] => {
  if (!resources) return [];
  return mergeSort(resources, compareResources);
};
